module.exports = __webpack_public_path__ + "img/暂无数据.dcd1c5c1.png";